"use client";

import React from 'react';
import Mission from '@/assets/images/missionBG.png'

const MissionSection = () => {

    return (
      <div 
          className='w-full h-[600px] bg-cover bg-center flex justify-center items-center mt-24'
          style={{backgroundImage: `url(${Mission})`}}
          data-aos="fade-up"
          data-aos-delay="800"
          data-aos-distance="1000px"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
      <div className='main_container'>
            <div 
              className='text-center'
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-duration="300"
              data-aos-easing="ease-in-out"
            >
              <p className='relative z-20 gradient_bg_text bg-grad-title text-center text-[60px] font-bold leading-[78px] tracking-[-1.6px] w-full'>
                What is our mission?
              </p>
              <p className='text-center text-[17px] text-textColor'>Our mission is to elevate blockchain development by addressing<br/> past flaws and propelling it into the next stage with enhanced<br/> security and efficiency.</p>
              <div className='px-8 py-2 border-[1px] border-button-border w-fit ml-auto mr-auto rounded-md mt-3 text-[15px] text-[#517FB4] cursor-pointer'>Read more...</div>
            </div>
        </div>
      </div>
    )
}

export default MissionSection;